export default __webpack_public_path__ + "static/media/companywideApprovers.4bbe4381.png";